module.exports = __webpack_public_path__ + "img/shuju1@2x.e8e1d6e6.png";